import { useSelector } from 'react-redux';
import { getAccountCards } from 'shared/config/store/reducers/cardsSlice';
import CardsLayout from '../components/CardsLayout/CardsLayout';
import { getCurrentEmi } from 'shared/config/store/selectors/app';
import { Account } from 'entities/account/model/types';
import { RootState } from 'shared/config/store/store';
import { getEMICurrentAccountObject } from 'shared/config/store/reducers/accountsSlice';

const CardPage = () => {
  const currentEmi = useSelector(getCurrentEmi);
  const currentAccount: Account = useSelector((state: RootState) =>
    getEMICurrentAccountObject(state, currentEmi)
  ) as Account;
  const card = useSelector(getAccountCards(currentEmi, currentAccount.id))?.[0];

  return (
    <>
      <CardsLayout
        card={card}
        accountId={currentAccount.id}
      />
    </>
  );
};

export default CardPage;
